import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const moderateContentFn = httpsCallable(functions, 'moderateContent');

/**
 * Check if content passes AI moderation
 * @param {string} title - Content title
 * @param {string} text - Content text/description
 * @param {string} contentType - Type of content (idea, story, domain)
 * @returns {Promise<{decision: string, reason: string, confidence: number}>}
 */
export async function moderateContent(title, text, contentType = 'post') {
  try {
    const result = await moderateContentFn({ title, text, contentType });
    return result.data;
  } catch (error) {
    console.error('Moderation error:', error);
    // Fail open - allow content if moderation service is down
    return {
      decision: 'ALLOW',
      reason: 'Moderation service unavailable',
      confidence: 0.5,
      error: true
    };
  }
}
